<template>
    <div v-if="sections" class="page-menu-wrapper">
        <div class="page-menu" :class="[props.menuColor, { active: y < 300 }, { expanded: expanded }]">
            <div class="menu-placeholder d-block d-md-none" @click="expanded = !expanded">Go To</div>
            <div class="menu-items">
                <a v-for="section in sections" :href="`#${section.id}`" class="menu-item to-section" @click.prevent="goTo(section)">
                    <span class="title">{{ section.title }}</span>
                    <span class="dot" :class="props.dotColor"></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, nextTick } from 'vue';
    import { useWindowScroll } from '@vueuse/core';

    const props = defineProps(["menuColor", "dotColor"]);

    const sections = ref(null);
    const expanded = ref(false);

    const { x, y } = useWindowScroll();

    function goTo(section) {
        const el = document.getElementById(section.id);
        const navbar = document.querySelector('.port-navbar');

        if (el) {
            const rect = el.getBoundingClientRect();
            //const navbarHeight = navbar ? navbar.offsetHeight : 0;
            // I HATE THIS BUT THE NAVBAR CHANGES SIZE ON SCROLL OVER .5 SECONDS AND THERE'S NO WAY TO DETECT IT IN TIME
            const navbarHeight = window.innerWidth < 768 ? 110 : 60;
            const targetY = rect.top + y.value - navbarHeight;
            y.value = targetY;
        }

        expanded.value = false;
    }

    function setupScrollspy(sectionEls) {
        const mainEl = document.querySelector("main");
        window.bootstrap.ScrollSpy.getOrCreateInstance(mainEl, {
            target: "#page-menu"
        });
    }

    onMounted(() => {
        // find all sections with data-title attribute
        const sectionEls = document.querySelectorAll('section.data-anchor');
        sections.value = Array.from(sectionEls).map(el => ({
            id: el.id,
            title: el.getAttribute('data-sectiontitle')
        }));
        nextTick(() => {
            setupScrollspy(sectionEls);
        });
    });
</script>